import { ApplicantType } from "../types";

export const ApplicantRoleLabel = {
  [ApplicantType.Applicant]: "Applicant",
  [ApplicantType.CoSigner]: "Guarantor",
  [ApplicantType.Occupant]: "Occupant"
};
